import React from 'react';
import { ColumnConfig, RichTableState } from './types';
import { LayoutChangeEvent, StyleProp, View, ViewStyle } from 'react-native';
import { GetTableCellLayoutHandlerArgs } from '../../../hooks/useTableCellDimensions';
import Text from '../Text';
import SortToggle from './SortToggle';
import Stack from '../Stack';
import { colors } from '../../../utils/theme';

export type TableColumnHeaderOwnProps<TDataElement> = {
    columnConfig: ColumnConfig<TDataElement>;
    getCellStyle: (index: number) => StyleProp<ViewStyle>;
    getTableCellLayoutHandler: (colIndex: GetTableCellLayoutHandlerArgs) => (event: LayoutChangeEvent) => void;
    padding: number;
    colIndex: number;
    data: TDataElement[];
    onStateChange: (newState: RichTableState) => void;
    state: RichTableState;
    isLast: boolean;
};

export type TableColumnHeaderProps<TDataElement> = TableColumnHeaderOwnProps<TDataElement>;

function TableColumnHeader<TDataElement>(props: TableColumnHeaderProps<TDataElement>) {
    return (
        <View
            style={[
                {
                    paddingLeft: props.padding,
                    paddingRight: props.padding,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    flexDirection: 'row',
                    width: '100%',
                    borderRightWidth: props.isLast ? 0 : 1,
                    borderRightColor: colors['Dividers'],
                    minHeight: 37,
                },
                props.getCellStyle(props.colIndex),
            ]}
            onLayout={props.getTableCellLayoutHandler({
                isHeader: true,
                colIndex: props.colIndex,
                contentKey: props.columnConfig.label,
            })}
        >
            <Stack horizontal fullWidth align="center">
                <Text variant="table-header">{props.columnConfig.label}</Text>
                <SortToggle
                    style={{ paddingLeft: 8 }}
                    columnConfig={props.columnConfig}
                    state={props.state}
                    onStateChange={props.onStateChange}
                    data={props.data}
                />
            </Stack>
        </View>
    );
}

export default React.memo(TableColumnHeader);
